import { useMemo } from 'react';

import { useMarketPrices } from '@/services';
import { EventMarket } from '@/types';

const parseTokens = (clobTokenIds?: string | string[]) => {
  if (!clobTokenIds) return [];
  try {
    if (typeof clobTokenIds === 'string') {
      const parsed = JSON.parse(clobTokenIds);
      return Array.isArray(parsed) ? parsed : [clobTokenIds];
    }
    return Array.isArray(clobTokenIds) ? clobTokenIds : [clobTokenIds as string];
  } catch {
    return [clobTokenIds as string];
  }
};

export const useRealtimeMarketPrices = (
  activeMarket: EventMarket | undefined,
  homeMarket: EventMarket | undefined,
  awayMarket: EventMarket | undefined,
  drawMarket: EventMarket | undefined
) => {
  const allTokenIds = useMemo(() => {
    const tokens = parseTokens(activeMarket?.clobTokenIds);
    const hTokens = parseTokens(homeMarket?.clobTokenIds);
    const aTokens = parseTokens(awayMarket?.clobTokenIds);
    const dTokens = parseTokens(drawMarket?.clobTokenIds);
    return Array.from(new Set([...tokens, ...hTokens, ...aTokens, ...dTokens]));
  }, [activeMarket, homeMarket, awayMarket, drawMarket]);

  const { data: realtimePrices } = useMarketPrices(allTokenIds, true);

  const getPriceUpdate = (index: number, marketOverride?: EventMarket) => {
    const targetMarket = marketOverride || activeMarket;
    if (!targetMarket?.priceMetadata) return null;
    const tokens = parseTokens(targetMarket.clobTokenIds);
    const tokenId = tokens[index];
    return tokenId ? targetMarket.priceMetadata[tokenId] : null;
  };

  return { realtimePrices, getPriceUpdate };
};
